import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPost,
  likePost,
  savePost,
} from "../../features/postDetails/postDetailsSlice";
import Loading from "../ui/Loading";
import Message from "../ui/Message";
function Details({ id }) {
  const dispatch = useDispatch();
  const { isLoading, post, error } = useSelector((state) => state.post);

  useEffect(() => {
    dispatch(fetchPost(id));
  }, [dispatch, id]);

  function handleSave() {
    dispatch(
      savePost({ id: id, payload: JSON.stringify({ isSaved: !post.isSaved }) })
    );
  }

  function handleLike() {
    dispatch(
      likePost({ id: id, payload: JSON.stringify({ likes: post.likes + 1 }) })
    );
  }

  let content = null;

  if (isLoading) content = <Loading />;
  if (!isLoading && !!error)
    content = (
      <Message text={`Error Fetching Posts. Error Message: ${error}`} />
    );
  if (!isLoading && !error && !!post.title)
    content = (
      <>
        <img
          src={post?.image}
          alt="githum"
          className="w-full rounded-md"
          id="lws-megaThumb"
        />
        <div>
          <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
            {post?.title}
          </h1>
          <div className="tags" id="lws-singleTags">
            {post?.tags?.map((tag) => `#${tag}`).join(", ")}
            {/* <span>#python,</span> <span>#tech,</span> <span>#git</span> */}
          </div>
          <div className="btn-group">
            {/* <!-- handle like on button click --> */}
            <button
              className="like-btn"
              id="lws-singleLinks"
              onClick={handleLike}
            >
              <i className="fa-regular fa-thumbs-up"></i> {post?.likes}
            </button>
            {/* <!-- handle save on button click --> */}
            {/* <!-- use ".active" class and "Saved" text  if a post is saved, other wise "Save" --> */}
            <button
              className={post?.isSaved ? "active save-btn" : "save-btn"}
              id="lws-singleSavedBtn"
              onClick={handleSave}
            >
              <i className="fa-regular fa-bookmark"></i>{" "}
              {post?.isSaved ? "Saved" : "Save"}
            </button>
          </div>
          <div className="mt-6">
            <p>{post?.description}</p>
          </div>
        </div>
      </>
    );

  return <main className="post">{content}</main>;
}

export default Details;
